import { Link } from '@tanstack/react-router'
import { cn } from '@workspace/ui/lib/utils'
import { useOverviewQuery } from '../hooks/api'

export function ProfileCompletenessCard({ startupId }: { startupId: string }) {
  const overviewQuery = useOverviewQuery(startupId)
  const completeness = overviewQuery.data?.data?.profileCompleteness

  if (!completeness) return null
  if (completeness.percentage >= 100 && completeness.nextSteps.length === 0) return null

  const { percentage, nextSteps } = completeness
  const barColor =
    percentage >= 80 ? 'bg-emerald-400' : percentage >= 50 ? 'bg-amber-400' : 'bg-primary'
  const textColor =
    percentage >= 80 ? 'text-emerald-400' : percentage >= 50 ? 'text-amber-400' : 'text-primary'

  return (
    <div className="rounded-xl border border-border/60 bg-card/30">
      <div className="px-5 py-3.5">
        <div className="flex items-center gap-4">
          <div className="flex shrink-0 items-center gap-2">
            <span className="text-sm text-muted-foreground">Profile:</span>
            <span className={cn('text-sm font-bold tabular-nums', textColor)}>{percentage}%</span>
            <span className="text-sm text-muted-foreground">complete</span>
          </div>
          <div className="relative h-2 min-w-24 flex-1 overflow-hidden rounded-full bg-zinc-800">
            <div
              className={cn('h-full rounded-full', barColor)}
              style={{ width: `${percentage}%` }}
            />
          </div>
        </div>
      </div>

      {nextSteps.length > 0 && (
        <div className="flex flex-wrap items-center gap-2 border-t border-border/40 px-5 py-2.5">
          <span className="text-[10px] text-muted-foreground/50">Next:</span>
          {nextSteps.slice(0, 5).map((step) => {
            const chipClassName = cn(
              'rounded-full border border-border/40 px-2.5 py-0.5 text-[11px] transition-colors hover:bg-card/50',
              textColor
            )
            const label = (
              <>
                {step.label} <span className="text-muted-foreground/50">+{step.boost}%</span>
              </>
            )
            return step.link === '/pitch' ? (
              <Link
                key={step.key}
                to="/app/startup/$id/pitch"
                params={{ id: startupId }}
                className={chipClassName}
              >
                {label}
              </Link>
            ) : (
              <Link
                key={step.key}
                to="/app/startup/$id/profile"
                params={{ id: startupId }}
                search={{ focus: step.key }}
                className={chipClassName}
              >
                {label}
              </Link>
            )
          })}
        </div>
      )}
    </div>
  )
}
